import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, LogIn } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_invest-links/artifacts/kydgz8tm_WhatsApp%20Image%202025-08-23%20at%203.47.06%20PM.jpeg';

const LINKS = [
  { to: '/', label: 'Home' },
  { to: '/welcome', label: 'About' },
  { to: '/courses', label: 'Courses' },
  { to: '/free-learning', label: 'Free Learning' },
  { to: '/market-snapshot', label: 'Daily Snapshot' },
  { to: '/market-intelligence', label: 'Market Intelligence' },
  { to: '/masterclass', label: 'Masterclass' },
  { to: '/workshop', label: 'Workshop' },
];

const isActive = (pathname, to) => {
  if (to === '/') return pathname === '/' || pathname === '/market-intelligence';
  if (to === '/welcome') return pathname === '/welcome' || pathname === '/home';
  if (to === '/market-snapshot') return pathname.startsWith('/market-snapshot');
  return pathname.startsWith(to);
};

const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <header className="fixed top-0 w-full bg-black/90 backdrop-blur-md z-50 border-b border-golden/40" data-testid="site-header">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2" data-testid="site-header-logo">
          <img src={LOGO_URL} alt="Upper Circuit Stocks" className="h-10 md:h-12 w-auto" />
        </Link>

        <nav className="hidden md:flex items-center space-x-5">
          {LINKS.map((l) => {
            const active = isActive(pathname, l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`site-nav-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                className={`transition-colors text-sm ${active
                  ? 'text-golden-light font-semibold border-b-2 border-golden pb-0.5'
                  : 'text-golden hover:text-golden-light'}`}
              >
                {l.label}
              </Link>
            );
          })}
          <Link
            to="/login"
            data-testid="site-nav-login"
            className="bg-golden hover:bg-golden/90 text-black font-semibold px-4 py-2 rounded-lg transition-colors flex items-center gap-2 text-sm"
          >
            <LogIn className="w-4 h-4" /> Login
          </Link>
        </nav>

        <div className="md:hidden flex items-center gap-2">
          <Link to="/login" className="bg-golden text-black font-semibold px-3 py-1.5 rounded-lg text-sm">Login</Link>
          <button
            onClick={() => setOpen((v) => !v)}
            className="p-2 text-golden hover:bg-golden/10 rounded-lg"
            data-testid="site-header-mobile-btn"
            aria-label="Toggle menu"
          >
            {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 border-t border-golden/20 px-4 py-3 space-y-1" data-testid="site-header-mobile-menu">
          {LINKS.map((l) => {
            const active = isActive(pathname, l.to);
            return (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className={`block px-3 py-2.5 rounded-lg text-sm transition-colors ${active
                  ? 'bg-golden/15 text-golden-light font-semibold'
                  : 'text-golden hover:bg-golden/10'}`}
              >
                {l.label}
              </Link>
            );
          })}
        </div>
      )}
    </header>
  );
};

export default SiteHeader;
